import React from "react";
import {useRef} from 'react'
import { Box, Typography, Grid, Button, Container, Card } from "@mui/material";
import ambassador from "../assets/ambassador.jpg";
import AmbassadorForm from "./AmbassadorForm";
import { Zoom } from "@mui/material";
import { Grow } from "@mui/material";
import { Slide } from "@mui/material";

const AboutAmbassador = () => {




  const formRef = useRef(null);




  const scrollToForm = () => {
    formRef.current.scrollIntoView({
      behavior: "smooth", // Smooth scrolling
      block: "start",     // Align the form to the top of the viewport
      inline:"nearest"
    });
  };
  return (
    <Slide direction="up" in={true} timeout={500}>
      <Container
        maxwidth={false}
        sx={{
          maxwidth: "1300px",
          marginTop: { xs: "0px", sm: "80px", lg: "50px" },
          marginBottom: { xs: "5px", sm: "80px", lg: "0px" },
        }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column", // Ensure vertical stacking on smaller screens
            justifyContent: "center", // Center content vertically
            padding: { xs: "0px", sm: "20px" },
            marginBottom: { xs: "0px", md: "0px" },
          }}>
          <Grid
            container
            spacing={2}
            alignItems="center"
            sx={{ marginBottom: { xs: "10px", lg: "10px" } }}>
            {/*  left column */}
            <Grid item xs={12} md={8}>
              <Typography variant="h6">About</Typography>
              <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                SAVA Ambassador
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: "20px" }}>
                SAVA Ambassador is a representative registered by the company,
                to facilitate loan screening processes requested by the
                customers on the SAVA platform.
              </Typography>

              <Typography variant="body1">
                Each ambassador will be entitled to the specific TILL number for
                identification purposes and will be required during the loan
                application process on the customer SAVA Loan app
              </Typography>

              <Button
                variant="contained" // Use a Material-UI contained button for emphasis
                color="primary" // Choose the primary color for the button
                onClick={scrollToForm}
                sx={{
                  padding: "5px 20px", // Customize padding
                  fontSize: "14px", // Adjust font size
                  borderRadius: "5px", // Optional rounded corners
                  marginTop: "20px",
                }}>
                Apply Now
              </Button>
            </Grid>

            {/* Left Column (Image) */}
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}>
                <Card></Card>

                <Zoom in={true} timeout={100}>
                  <img
                    src={ambassador}
                    alt="About"
                    style={{
                      borderRadius: "8px",
                      maxWidth: "79%",
                      width: {
                        xs: "100%", // Full width for xs screens
                        sm: "50px", // 50px width for sm screens
                        md: "200px", // 200px width for md screens
                        lg: "250px", // 250px width for lg screens
                      },
                      height: "auto",
                    }}
                  />
                </Zoom>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/*    -----eligibility criteria to become ambassador----- */}
        <Grid container spacing={2}>
          {/* First Grid Item */}

          <Grid item xs={12} sm={6} md={4}>
            <Grow in={true} timeout={1000}>
              <Card
                sx={{
                  backgroundColor: "white",
                  padding: "20px",
                  height: { xs: "auto", sm: "350px" },
                  border: "solid 1px lightgrey",
                }}>
                <Typography color="black" variant="h5" fontWeight="bold">
                  Eligibility Criteria
                </Typography>
                <Typography color="black" variant="h6">
                  SAVA Ambassador
                </Typography>
                <Typography color="black" variant="body1">
                  <ul>
                    <li>Commissions and bonuses for each fully repaid loan.</li>
                    <li>
                      An all-expenses-paid trip to the annual Sava Ambassadors
                      General Meeting.
                    </li>
                    <li>
                      Access to financial training and educational resources.
                    </li>
                    <li>Access to the Sava Ambassador mobile app.</li>
                  </ul>
                </Typography>
              </Card>
            </Grow>
          </Grid>

          {/* Second Grid Item */}
          <Grid item xs={12} sm={6} md={4}>
            <Grow in={true} timeout={1000}>
              <Card
                sx={{
                  backgroundColor: "white",
                  padding: "20px",
                  height: { xs: "auto", sm: "350px" },
                  border: "solid 1px lightgrey",
                }}>
                <Typography color="black" variant="h5" fontWeight="bold">
                  Steps to become
                </Typography>
                <Typography color="black" variant="h6">
                  SAVA Ambassador
                </Typography>
                <Typography color="black" variant="body1">
                  <ul>
                    <li>
                      Must be a registered business (Sole Proprietorship,
                      Company, Partnership) or a recognized group (Vicoba,
                      Saccos).
                    </li>
                    <li>
                      Individuals must provide a valid, certified copy of their
                      NIDA ID along with a letter from the local government
                      authority.
                    </li>
                    <li>
                      Complete the ambassador request form and submit all
                      necessary information.
                    </li>
                    <li>A valid physical address is required.</li>
                  </ul>
                </Typography>
              </Card>
            </Grow>
          </Grid>

          {/* Third Grid Item */}
          <Grid item xs={12} sm={6} md={4}>
            <Grow in={true} timeout={1000}>
              <Card
                sx={{
                  backgroundColor: "white",
                  padding: "20px",
                  height: { xs: "auto", sm: "350px" },
                  border: "solid 1px lightgrey",
                }}>
                <Typography color="black" variant="h5" fontWeight="bold">
                  Benefits of Becoming
                </Typography>
                <Typography color="black" variant="h6">
                  SAVA Ambassador
                </Typography>
                <Typography color="black" variant="body1">
                  <ul>
                    <li>Commissions and bonuses for each fully repaid loan.</li>
                    <li>
                      An all-expenses-paid trip to the annual Sava Ambassadors
                      General Meeting.
                    </li>
                    <li>
                      Access to financial training and educational resources.
                    </li>
                    <li>Access to the Sava Ambassador mobile app.</li>
                  </ul>
                </Typography>
              </Card>
            </Grow>
          </Grid>
        </Grid>

        <Box sx={{ marginTop: { xs: "15px", sm: "50px" } }}>
          <Box sx={{ marginX: { xs: "1px", sm: "150px" } }}>
            <Box>
              <Typography variant="h6">
                Start Your Journey as a SAVA Ambassador!
              </Typography>
              <Typography variant="body1">
                Become a key player in facilitating loan screening processes for
                our customers on the SAVA platform. As a SAVA Ambassador, you’ll
                be equipped with a unique TILL number for identification,
                enhancing the loan application experience on the SAVA Loan app.
                Join us in making financial solutions more accessible and
                support our community in their journey toward achieving their
                goals!
              </Typography>
            </Box>
          </Box>


<Box ref={formRef}>
<AmbassadorForm />
</Box>
         
        </Box>
      </Container>
    </Slide>
  );
};

export default AboutAmbassador;
